import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider  = ({ children }) => {

    const [ modalStack, setModalStack ] = useState([]);

    const openModal = ( id ) => setModalStack(( stack ) => [ ...stack, id ]);
    const closeModal = () => 
        setModalStack(( stack ) => stack.slice( 0, stack.length - 1 ));

    const isModalOpen = ( id ) => modalStack.includes( id );
    const getTopModal = () => modalStack[ modalStack.length - 1 ];

    const clearAllModal = () => setModalStack([])

    return(
        <ModalContext.Provider value={{ isModalOpen, openModal, closeModal, getTopModal, clearAllModal }} >
            { children }
        </ModalContext.Provider>
    )

}

export const useModal = () => useContext( ModalContext )